// this file is automatically generated by git.version.ts script
export const versions = {version: '1.37.0', revision: 'd8ccffe', branch: 'HEAD'};
